export default __webpack_public_path__ + "static/fr-b02766c1681969b97000dfa836a7097e.svg";